const defaultBaseUrl = () => (
    typeof window !== 'undefined' && window.location?.origin
        ? window.location.origin
        : 'http://localhost:3000'
);

export const resolveGraphQLUris = (
    configuredUri,
    {
        isProduction = process.env.NODE_ENV === 'production',
        baseUrl = defaultBaseUrl(),
    } = {}
) => {
    const candidate = configuredUri || (
        isProduction ? null : 'http://localhost:3000/graphql'
    );
    if (!candidate) {
        throw new Error('REACT_APP_GRAPHQL_URI is required in production');
    }

    let httpUrl;
    try {
        httpUrl = new URL(candidate, baseUrl);
    } catch {
        throw new Error('REACT_APP_GRAPHQL_URI must be a valid URL');
    }

    if (!['http:', 'https:'].includes(httpUrl.protocol)) {
        throw new Error('REACT_APP_GRAPHQL_URI must use HTTP or HTTPS');
    }
    if (isProduction && httpUrl.protocol !== 'https:') {
        throw new Error('REACT_APP_GRAPHQL_URI must use HTTPS in production');
    }
    if (httpUrl.username || httpUrl.password) {
        throw new Error('REACT_APP_GRAPHQL_URI must not contain credentials');
    }

    const wsUrl = new URL(httpUrl.toString());
    wsUrl.protocol = httpUrl.protocol === 'https:' ? 'wss:' : 'ws:';
    return {
        httpUri: httpUrl.toString(),
        wsUri: wsUrl.toString(),
    };
};
